import React from "react";
import { LandingPage } from "@harrow-education/ui-components";

const Landing = ({ onContactUs, onSignIn }) => {
  return <LandingPage onContactUs={onContactUs} onSignIn={onSignIn} />;
};

export default Landing;
